import { render, staticRenderFns } from "./VCategories.vue?vue&type=template&id=6328435a"
import script from "./VCategories.vue?vue&type=script&lang=js"
export * from "./VCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports